import { FC } from 'react'
import { useFormik } from 'formik'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button } from '../../../../../components/Button/Button'
import { FormTextArea } from '../../../../../components/Form/FormTextArea'
import { LoadingIndicator } from '../../../../../components/Loading/LoadingIndicator'
import { useModal } from '../../../../../components/Modal/ModalContext'
import { TriagemRiscoBadge } from '../../../../../components/TriagemRisco/TriagemRiscoBadge'
import { ButtonType } from '../../../../../../_metronic/helpers/enumsUI'
import { showError } from '../../../../../../_metronic/helpers/AlertHelper'
import { CorTriagem } from '../../../../../components/TriagemRisco/riscoTriagem'
import { TriagemHistorico } from '../../../triagem/core/_models'
import { registrarDecisaoTriagem } from '../../../triagem/core/_requests'

type ConfirmarClassificacaoTriagemModalProps = {
  idTriagem: number
  corEfetiva?: CorTriagem
  onDecisao: (historico: TriagemHistorico) => void
}

/**
 * Confirmação da classificação do motor. Mantém a cor e registra a supervisão médica — é o que
 * permite medir depois quanto o médico concorda com o motor (T6). O motivo aqui é opcional.
 */
export const ConfirmarClassificacaoTriagemModal: FC<ConfirmarClassificacaoTriagemModalProps> = ({
  idTriagem,
  corEfetiva,
  onDecisao,
}) => {
  const { closeModal } = useModal()
  const { t } = useT()

  const formik = useFormik<{ motivo: string }>({
    initialValues: { motivo: '' },
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const historico = await registrarDecisaoTriagem(idTriagem, {
          acao: 'CONFIRMAR',
          motivo: values.motivo || undefined,
        })
        onDecisao(historico)
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <p className='d-flex align-items-center gap-2'>
        <TriagemRiscoBadge cor={corEfetiva} /> {t('triagem.decisao.confirmar_texto')}
      </p>
      <FormTextArea
        className='mb-4'
        name='motivo'
        label={t('triagem.decisao.observacao_opcional')}
        formik={formik}
        rows={3}
      />
      <div className='d-flex justify-content-end gap-2'>
        <Button className='btn-secondary' onClick={closeModal}>
          {t('common.cancel', undefined, 'Cancelar')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('triagem.confirmar')}
        </Button>
      </div>
    </form>
  )
}
